export enum MAPPING_TABLE_STEPS {
  CONFIGURE_MAPPING_TABLE,
  SELECT_QUESTION_GROUPS,
  TABLE_CELLS_OVERVIEW,
  ADD_CELL,
  EDIT_CELL,
  REVIEW_DETAILS,
}

export enum MAPPING_TABLE_ORIENTATIONS {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
  CARD = 'card',
}

export enum MAPPING_TABLE_MODE {
  QUESTIONNAIRE = 'questionnaire',
  CALCULATIONS = 'calculations',
  UNKNOWN = 'unknown',
}

export enum MAPPING_TABLE_RENDERING_MODE {
  STACKED = 'stacked',
  FLATTENED = 'flattened',
}

export enum QuestionGroupFieldEnum {
  name = 'Name',
  asset_status = 'Asset Status',
  asset_category = 'Asset Category',
  income_type = 'Income Type',
}

export const MIN_COLUMN_WIDTH = 30;

export const questionGroupFieldTypes = Object.entries(
  QuestionGroupFieldEnum
).map(([type, label]) => ({ type, label }));

export type QuestionGroupField = keyof typeof QuestionGroupFieldEnum;

export enum HouseholdMemberFieldEnum {
  number = 'Household Member Number',
  first_and_last = 'Household Member First and Last Name',
}

export const householdMemberFieldTypes = Object.entries(
  HouseholdMemberFieldEnum
).map(([type, label]) => ({ type, label }));

export type HouseholdMemberField = keyof typeof HouseholdMemberFieldEnum;
